'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './jurisdictions.routes';

export class JurisdictionsComponent {
  /*@ngInject*/
  constructor($scope, lookup, fetch, userService) {
    this.$scope = $scope;
    this.lookup = lookup;
    this.fetch = fetch;

    this.userService = userService;

    $scope.rowCollection = [];
    $scope.filteredCollection = [];
   
    $scope.updateTocActive = function(item) {
      // Log the current state of toc_active
      console.log('Current toc_active for', item.jurisdiction_id, ':', item.toc_active);
      var data = {
        jurisdiction_id: item.jurisdiction_id,
        toc_active: item.toc_active
      }
      // Here you can add additional logic, like updating a database, if needed
      // For example, if you have an API to update the database:
      
      fetch.updateItem(`api/data/jurisdictions/update-toc-active`, data)
          .then(response => {
              console.log('Update successful:', response);
          })
          .catch(error => {
              console.error('Error updating toc_active:', error);
          });
      
  };
  }

  $onInit(){
    
    this.userService.getCurrentUser()
    .then(response => {
      
      this.$scope.currentUser = response.data;
      this.userService.setCurrentUser(response.data);
      this.getJurisdictionList();

      
    })
    .catch(err => {
      console.log(err);
      if(err.status === 403){
        this.$state.go('login');
      }
    })


  }

  getJurisdictionList() {
  
    this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-admin')
      .then(response => {
        console.log(response.data);
        this.$scope.rowCollection = response.data;
        this.$scope.filteredCollection = this.$scope.rowCollection;
      })
      .catch(err => {
        console.log(err);
        if(err.status === 403){
          this.$state.go('login');
        }
      })

    // this.$scope.getStationAreaList();


}
}

export default angular.module('appApp.jurisdictions', [uiRouter, 'smart-table'])
  .config(routes)
  .component('jurisdictions', {
    template: require('./jurisdictions.html'),
    controller: JurisdictionsComponent,
    controllerAs: 'jurisdictionsCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/compliance/jurisdictions/jurisdictions.component.js